import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { AccountService } from '@banyan/features/account/services/account.service';
import { environment } from '@env/environment';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';

export async function runAuthInit(
  oauthService: OAuthService,
  accountService: AccountService,
  document: Document,
  platformId: any,
): Promise<void> {
  try {
    if (!isPlatformBrowser(platformId)) {
      return;
    }

    const origin = document.defaultView?.origin ?? environment.domain;
    const authOriginal = environment.auth;

    const auth: AuthConfig = {
      ...authOriginal,
      redirectUri: `${origin}${authOriginal.redirectUri}`,
      postLogoutRedirectUri: `${authOriginal.postLogoutRedirectUri}`,
    };

    oauthService.configure(auth);
    await oauthService.loadDiscoveryDocument();
    oauthService.setupAutomaticSilentRefresh();
    accountService.checkLoginStatus();
  } catch (e) {
    console.log('error when initializing auth', e);
  }
}

export function authInitializer(): () => Promise<void> {
  return () =>
    runAuthInit(
      inject(OAuthService),
      inject(AccountService),
      inject(DOCUMENT),
      inject(PLATFORM_ID)
    );
}
